// removed by extract-text-webpack-plugin
module.exports = {"SettingsPageTitle":"SettingsPageTitle---3Q6BG"};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/components/shared/PageTitle/style.styl
// module id = D5Pz
// module chunks = 89